import { AuthorLike } from '../types/entity';
import { messages } from './i18n/i18n';
import { ProcessProcessStatusEnum } from '@redviking/argonaut-util/types/db-enums/process';

export function userToString<U extends AuthorLike> (user?: U | null) {
    return messages.userToString({ user });
}

export function formatTs (format: keyof typeof messages.tsFormatters, date: unknown) {
    if (typeof date === 'string' || typeof date === 'number' || (typeof date === 'object' && date instanceof Date)) {
        return messages.tsFormatters.short.format(new Date(date));
    }
    return '';
}

export const processStatusTransitionMap: {
    [status in ProcessProcessStatusEnum]: {
        text: string;
        icon: string;
        description: string;
        action?: string;
        rank: number;
        value: status;
        color: string;
        allowedTransitions: ProcessProcessStatusEnum[];
    }
} = {
    not_required: {
        rank: 5,
        color: 'grey',
        text: 'Not Required',
        allowedTransitions: [],
        icon: 'mdi-alert-circle-check',
        description: 'This process is not required for this material',
        value: ProcessProcessStatusEnum.NotRequired,
    },
    completed: {
        text: 'Completed',
        icon: 'mdi-check-bold',
        description: 'The process has met the required count and passed validations',
        value: ProcessProcessStatusEnum.Completed,
        color: 'success',
        rank: 2,
        allowedTransitions: [],
    },
    failed: {
        text: 'Failed',
        icon: 'mdi-close-thick',
        description: 'The process has failed and cannot be completed without manual intervention',
        value: ProcessProcessStatusEnum.Failed,
        color: 'error',
        rank: 4,
        allowedTransitions: [],
    },
    incomplete: {
        text: 'Incomplete',
        icon: 'mdi-timer-sand',
        description: 'The number of successful collection events has not reached the amount required by the solved specification',
        value: ProcessProcessStatusEnum.Incomplete,
        color: 'warning lighten-1',
        rank: 1,
        allowedTransitions: [
            ProcessProcessStatusEnum.ManuallyCompleted,
        ],
    },
    manually_completed: {
        text: 'Manually Completed',
        icon: 'mdi-account-check',
        description: 'The process has been manually marked as completed',
        action: 'Mark the process as completed',
        value: ProcessProcessStatusEnum.ManuallyCompleted,
        color: 'success lighten-1',
        rank: 3,
        allowedTransitions: [],
    },
};

export enum DurationFormat {
    Seconds = 's',
    Minutes = 'm',
    Hours = 'h',
    StopWatch = 'sw',
}

export enum TimeFormat {
    LongDateTime = 'long',
    ShortDateTime = 'short',
    LongDate = 'longDate',
    ShortDate = 'date',
    Time = 'time'
}

export function formatDuration (time: number, format: DurationFormat): string {
    let formattedTime = '';

    switch (format) {
        case DurationFormat.Seconds:
            formattedTime = `${String(time % 60).padStart(2, '0')}s`;
            break;
        case DurationFormat.Minutes:
            formattedTime = `${String(Math.trunc(time / 60) % 60).padStart(2, '0')}:${String(time % 60).padStart(2, '0')}`;
            break;
        case DurationFormat.Hours:
            formattedTime = `${Math.trunc(time / 3600)}h`;
            break;
        case DurationFormat.StopWatch:
            formattedTime = `${Math.trunc(time / 3600)}:${String(Math.trunc(time / 60) % 60).padStart(2, '0')}:${String(time % 60).padStart(2, '0')}`;
            break;
        default:
            formattedTime = `${Math.trunc(time / 3600)}:${String(Math.trunc(time / 60) % 60).padStart(2, '0')}:${String(time % 60).padStart(2, '0')}`;
            break;
    }

    return formattedTime;
}
